import { Component, OnDestroy } from '@angular/core';
import { LoginForm } from '@optsolservices/ngx-login-form';
import { AuthService } from '../../services/auth.service';
import { NotificationService } from '@optsolservices/ngx-notification';
import { User } from '../../models/user';
import { GeneralStoreService } from '../../store/general.store';
import { Token } from '../../models/token';
import { InvalidUsernamePassword, UserNotFound } from '../../models/errors';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { isEmpty } from 'lodash';
import { Subscription } from 'rxjs';
import { HelperService } from '../../services/helper.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnDestroy {

  private subscriptions: Subscription[] = [];
  private redirectUrl;
  private queryParams;

  constructor(
    private authService: AuthService,
    private notificationService: NotificationService,
    private generalStoreService: GeneralStoreService,
    private router: Router,
    private dialog: MatDialog,
    private helperService: HelperService,
  ) {
    this.queryParams = (this.router.getCurrentNavigation()?.extras?.state?.queryParams) || {};
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  async attempt(loginForm: LoginForm): Promise<void> {
    try {
      localStorage.clear();
      const response: Token = await this.authService.attempt(loginForm.username, loginForm.password).toPromise();
      if (!response.access_token) { throw new InvalidUsernamePassword(); }

      this.generalStoreService.setToken(response.access_token);

      const user: User = (await this.authService.logon().toPromise()).data;
      if (!user) { throw new UserNotFound(); }

      this.generalStoreService.setUser(user);
      this.generalStoreService.setOwners(user.owners || []);

      try {
        await this.helperService.getMenu();
      } catch (error) {
        this.generalStoreService.logout();
        this.notificationService.error('You are not linked to any roles, please contact your system administrator.');
        return;
      }
      let userLandingPageUrl = await this.helperService.getUserLandingPageUrl();
      this.redirectUrl = (this.router.getCurrentNavigation()?.extras?.state?.url) || userLandingPageUrl;

      if (!user.mustChangePassword) { return this.redirect(user, this.redirectUrl, this.queryParams); }

      const ref = this.dialog.open(ResetPasswordComponent, {
        data: { email: loginForm.username, currentPassword: loginForm.password, canCancel: false },
        width: '300px',
      });

      this.subscriptions.push(ref.afterClosed().subscribe((dialogResponse) => {
        if (isEmpty(dialogResponse)) { return; }
        this.redirect(user, this.redirectUrl, this.queryParams);
      }));

    } catch (error) {
      // this.notificationService.error(`Login failed: ${error?.error?.error_description}`);
    }
  }

  redirect(user: User, url: string, queryParams: object): void {
    user.mustChangePassword = false;
    this.generalStoreService.setUser(user);
    this.router.navigate([url], { queryParams });
  }
}
